import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function SlideClose() {
  return <div className="h-full w-full flex flex-col px-8 py-10 md:px-20 md:py-14 max-w-7xl mx-auto" data-id="element-108">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-109">
        <span className="text-teal-400 text-xs uppercase tracking-widest font-medium" data-id="element-110">
          Annual Partnership
        </span>
        <h2 className="text-3xl md:text-5xl font-serif text-white mt-3 mb-3" data-id="element-111">
          A managed <span className="text-teal-400" data-id="element-112">campaign engine</span> for
          Roche Africa.
        </h2>
        <p className="text-base text-white/60 max-w-3xl" data-id="element-113">
          One partnership. Multiple brands. Multiple markets. Continuous
          campaign learning.
        </p>
      </motion.div>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-12 gap-8 mt-10" data-id="element-114">
        {/* LEFT — Proposal Card */}
        <div className="lg:col-span-7" data-id="element-115">
          <div className="bg-navy-900/70 border border-navy-600 rounded-2xl p-8 h-full" data-id="element-116">
            <h3 className="text-xl font-serif text-white mb-8" data-id="element-117">
              Start focused. Prove fast. Scale smart.
            </h3>

            <div className="space-y-8 relative before:absolute before:inset-0 before:ml-[15px] before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-teal-400 before:via-teal-400/50 before:to-transparent" data-id="element-118">
              {/* Step 1 */}
              <div className="relative flex items-start gap-6 md:justify-center" data-id="element-119">
                <div className="hidden md:block w-1/2 text-right pr-8" data-id="element-120">
                  <h4 className="text-teal-400 font-medium text-lg" data-id="element-121">Pilot</h4>
                  <p className="text-white/60 text-sm mt-1" data-id="element-122">
                    Start with one priority brand in selected West African
                    markets
                  </p>
                </div>
                <div className="absolute left-0 md:left-1/2 w-8 h-8 rounded-full bg-navy-800 border-2 border-teal-400 flex items-center justify-center -translate-x-1/2 z-10" data-id="element-123">
                  <span className="text-teal-400 text-xs font-bold" data-id="element-124">1</span>
                </div>
                <div className="md:hidden w-full pl-12" data-id="element-125">
                  <h4 className="text-teal-400 font-medium text-lg" data-id="element-126">Pilot</h4>
                  <p className="text-white/60 text-sm mt-1" data-id="element-127">
                    Start with one priority brand in selected West African
                    markets
                  </p>
                </div>
                <div className="hidden md:block w-1/2 pl-8" data-id="element-128" />
              </div>

              {/* Step 2 */}
              <div className="relative flex items-start gap-6 md:justify-center" data-id="element-129">
                <div className="hidden md:block w-1/2 pr-8" data-id="element-130" />
                <div className="absolute left-0 md:left-1/2 w-8 h-8 rounded-full bg-navy-800 border-2 border-teal-400 flex items-center justify-center -translate-x-1/2 z-10" data-id="element-131">
                  <span className="text-teal-400 text-xs font-bold" data-id="element-132">2</span>
                </div>
                <div className="w-full pl-12 md:pl-8 md:w-1/2" data-id="element-133">
                  <h4 className="text-teal-400 font-medium text-lg" data-id="element-134">Prove</h4>
                  <p className="text-white/60 text-sm mt-1" data-id="element-135">
                    Measure engagement, CTA behaviour and country-level insights
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="relative flex items-start gap-6 md:justify-center" data-id="element-136">
                <div className="hidden md:block w-1/2 text-right pr-8" data-id="element-137">
                  <h4 className="text-teal-400 font-medium text-lg" data-id="element-138">Scale</h4>
                  <p className="text-white/60 text-sm mt-1" data-id="element-139">
                    Apply the learning loop across the Roche Africa portfolio
                  </p>
                </div>
                <div className="absolute left-0 md:left-1/2 w-8 h-8 rounded-full bg-teal-400 border-2 border-teal-400 flex items-center justify-center -translate-x-1/2 z-10" data-id="element-140">
                  <span className="text-navy-900 text-xs font-bold" data-id="element-141">3</span>
                </div>
                <div className="md:hidden w-full pl-12" data-id="element-142">
                  <h4 className="text-teal-400 font-medium text-lg" data-id="element-143">Scale</h4>
                  <p className="text-white/60 text-sm mt-1" data-id="element-144">
                    Apply the learning loop across the Roche Africa portfolio
                  </p>
                </div>
                <div className="hidden md:block w-1/2 pl-8" data-id="element-145" />
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT — Pricing Card */}
        <div className="lg:col-span-5 flex flex-col space-y-6" data-id="element-146">
          <div className="bg-teal-400/5 border border-teal-400/30 rounded-2xl p-8 flex-1" data-id="element-147">
            <h3 className="text-white/40 text-[10px] uppercase tracking-widest font-medium mb-6" data-id="element-148">
              Partnership Scope
            </h3>
            <ul className="space-y-4" data-id="element-149">
              {['Master Snak campaign setup', 'Country adaptation', 'Campaign launch support', 'Reporting and optimization', 'Ongoing campaign learning'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-150">
                  <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0" data-id="element-151" />
                  <span className="text-white/80 text-sm" data-id="element-152">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 p-4 bg-navy-900/50 rounded-xl border border-navy-700" data-id="element-153">
              <p className="text-white/50 text-xs leading-relaxed text-center" data-id="element-154">
                Pricing to be aligned based on number of brands, countries and
                campaign frequency.
              </p>
            </div>
          </div>

          <div className="border-l-2 border-teal-400/40 pl-4 py-2" data-id="element-155">
            <p className="text-white/80 text-sm font-medium" data-id="element-156">
              Same budget logic. Less internal burden. More measurable HCP
              action over time.
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-end mt-6" data-id="element-157">
        <Button onClick={() => window.location.reload()} data-id="element-158">
          Start with one brand
        </Button>
      </div>
    </div>;
}